import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api, resolveImageUrl } from '../lib/api';
import QrImg from '../components/QrImg';

const CATS = ['Comic', 'Illustration', 'Trinket', 'Original Character', 'Handcraft', 'Toys & Figures', 'Merchandise', 'Music', 'Experience', 'TCG', 'F&B'];
const fmtDl = (v) => {
  if (!v) return '-';
  const s = String(v);
  const d = new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(s) ? s : `${s}Z`);
  return isNaN(d) ? '-' : `${d.toLocaleString('id-ID', { timeZone: 'Asia/Jakarta', weekday: 'long', day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit' })} WIB`;
};
const dLeft = (v) => { const d = new Date(String(v)); return isNaN(d) ? null : Math.ceil((d.getTime() - Date.now()) / 86400000); };
const MIN_PRODUCTS = 3;
const MAX_PRODUCTS = 8;
const ASSET_SPEC = {
  logo: { label: 'Logo brand', minW: 600, minH: 600, ratio: 1, ratioTxt: '1:1 (persegi)', rec: '1000 x 1000 px' },
  cover: { label: 'Ilustrasi cover', minW: 1080, minH: 1440, ratio: 0.75, ratioTxt: '3:4 portrait', rec: '2160 x 2880 px' },
  product: { label: 'Foto produk', minW: 1080, minH: 1440, ratio: 0.75, ratioTxt: '3:4 portrait', rec: '2160 x 2880 px' },
};
const ASSET_ACCEPT = 'image/png,image/jpeg,image/webp';
function readImageSize(file) {
  return new Promise((resolve) => {
    try {
      const url = URL.createObjectURL(file);
      const img = new Image();
      img.onload = () => { resolve({ w: img.naturalWidth, h: img.naturalHeight }); URL.revokeObjectURL(url); };
      img.onerror = () => { resolve(null); URL.revokeObjectURL(url); };
      img.src = url;
    } catch (e) { resolve(null); }
  });
}
async function checkAsset(kind, file) {
  const sp = ASSET_SPEC[kind];
  if (!sp || !file) return '';
  if (!/\.(jpe?g|png|webp)$/i.test(file.name || '')) return 'Format file harus JPG, PNG, atau WEBP.';
  if (file.size > 25 * 1024 * 1024) return 'Ukuran file maksimal 25MB.';
  const d = await readImageSize(file);
  if (!d) return '';
  if (d.w < sp.minW || d.h < sp.minH) return `${sp.label} minimal ${sp.minW} x ${sp.minH} px (rasio ${sp.ratioTxt}). File kamu ${d.w} x ${d.h} px. Disarankan ${sp.rec}.`;
  if (Math.abs(d.w / d.h - sp.ratio) / sp.ratio > 0.04) return `${sp.label} harus rasio ${sp.ratioTxt}. File kamu ${d.w} x ${d.h} px. Crop dulu ke ${sp.ratioTxt}, contoh ${sp.rec}.`;
  return '';
}
const rp = (v) => `Rp${Math.round(Number(v) || 0).toLocaleString('id-ID')}`;
const errOf = (e, fb) => (e && e.response && e.response.data && e.response.data.detail) ? String(e.response.data.detail) : (fb || 'Terjadi kesalahan, coba lagi.');
const when = (v) => {
  if (!v) return '';
  const s = String(v);
  const d = new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(s) ? s : `${s}Z`);
  return isNaN(d) ? '' : d.toLocaleString('id-ID', { timeZone: 'Asia/Jakarta', day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) + ' WIB';
};
const CSS = `
@font-face { font-family: 'Akira Expanded'; src: url('/fonts/akira-expanded.otf') format('opentype'); font-display: swap; }
.tvp { min-height: 100vh; background-color: #ECEAE4; background-image: repeating-linear-gradient(0deg, rgba(17,17,17,.024) 0 1px, transparent 1px 28px), repeating-linear-gradient(90deg, rgba(17,17,17,.024) 0 1px, transparent 1px 28px); color: #111; font-family: 'DM Sans', system-ui, sans-serif; }
.tvp-wrap { max-width: 860px; margin: 0 auto; padding: 22px 16px 64px; }
.tvp-h { font-family: 'Akira Expanded', 'DM Sans', sans-serif; font-weight: 800; text-transform: uppercase; letter-spacing: -0.01em; line-height: 1.05; }
.tvp-lbl { display: block; font-family: 'Akira Expanded', 'DM Sans', sans-serif; font-size: 11px; font-weight: 800; letter-spacing: .06em; text-transform: uppercase; margin-bottom: 6px; }
.tvp-card { background: #fff; border: 2px solid #111; box-shadow: 6px 6px 0 #111; padding: 20px; }
.tvp-in { width: 100%; background: #fff; border: 1.5px solid #111; border-radius: 0; padding: 11px 12px; font-size: 15px; font-family: inherit; color: #111; outline: none; }
.tvp-in:focus { box-shadow: 3px 3px 0 #111; }
.tvp-btn { display: inline-flex; align-items: center; justify-content: center; gap: 8px; background: #CAFF00; color: #111; border: 2px solid #111; box-shadow: 5px 5px 0 #111; font-family: 'Akira Expanded', 'DM Sans', sans-serif; font-weight: 800; font-size: 14px; letter-spacing: .04em; text-transform: uppercase; padding: 14px 22px; cursor: pointer; transition: transform .12s, box-shadow .12s; }
.tvp-btn:hover { transform: translate(-2px,-2px); box-shadow: 7px 7px 0 #111; }
.tvp-btn:active { transform: translate(2px,2px); box-shadow: 2px 2px 0 #111; }
.tvp-btn:disabled { opacity: .5; cursor: not-allowed; transform: none; }
.tvp-btn.ghost { background: #fff; font-size: 11px; padding: 9px 14px; box-shadow: 3px 3px 0 #111; }
.tvp-chip { display: inline-flex; align-items: center; gap: 6px; border: 1.5px solid #111; padding: 7px 11px; font-size: 13px; font-weight: 600; cursor: pointer; background: #fff; user-select: none; }
.tvp-chip.on { background: #111; color: #CAFF00; }
.tvp-step { flex: 1; border: 2px solid #111; padding: 10px 8px; text-align: center; background: #fff; cursor: pointer; }
.tvp-step.on { background: #111; color: #CAFF00; }
.tvp-step.done { background: #CAFF00; }
.tvp-note { border: 2px solid #111; background: #FFF6CC; padding: 12px 14px; font-size: 14px; line-height: 1.55; }
.tvp-ok { border: 2px solid #111; background: #DDFBC8; padding: 12px 14px; font-size: 14px; line-height: 1.55; }
.tvp-bad { border: 2px solid #111; background: #FFD9D2; padding: 12px 14px; font-size: 14px; line-height: 1.55; }
.tvp-table { width: 100%; border-collapse: collapse; font-size: 14px; }
.tvp-table td { padding: 9px 4px; border-bottom: 1px solid rgba(17,17,17,.15); vertical-align: top; }
.tvp-spec th { background: #111; color: #CAFF00; font-size: 11px; letter-spacing: .08em; text-transform: uppercase; padding: 8px 10px; text-align: left; white-space: nowrap; }
.tvp-spec td { padding: 8px 10px; font-size: 13px; white-space: nowrap; }
.tvp-qty { display: inline-flex; align-items: center; border: 1.5px solid #111; }
.tvp-qty button { width: 34px; height: 34px; background: #fff; border: 0; font-size: 18px; font-weight: 800; cursor: pointer; }
.tvp-qty span { min-width: 36px; text-align: center; font-weight: 800; border-left: 1.5px solid #111; border-right: 1.5px solid #111; line-height: 34px; }
.tvp-pks { max-height: 260px; overflow-y: auto; white-space: pre-wrap; border: 1.5px solid #111; background: #FAFAF7; padding: 12px; font-size: 13px; line-height: 1.6; }
.tvp-tag { display: inline-flex; align-items: center; gap: 6px; border: 1.5px solid #111; padding: 5px 10px; font-size: 12px; font-weight: 700; background: #fff; }
.tvp-tag.ok { background: #CAFF00; }
.tvp-guide { border: 2px solid #111; background: #FAFAF7; padding: 12px; display: grid; gap: 10px; align-content: start; }
.tvp-guide img { width: 100%; display: block; border: 1.5px solid #111; }
.tvp-guide ul { margin: 0; padding-left: 18px; font-size: 13px; line-height: 1.55; }
.tvp-drop { border: 2px dashed #111; background: #FAFAF7; display: grid; place-items: center; text-align: center; cursor: pointer; padding: 18px; font-size: 13px; }
`;

function Field({ label, children, hint }) {
  return (
    <label style={{ display: 'block' }}>
      <span className="tvp-lbl">{label}</span>
      {children}
      {hint && <span style={{ display: 'block', fontSize: 12, color: '#555', marginTop: 4 }}>{hint}</span>}
    </label>
  );
}

function SignaturePad({ onChange, disabled }) {
  const ref = useRef(null);
  const drawing = useRef(false);
  const last = useRef(null);
  const [empty, setEmpty] = useState(true);
  const setup = () => {
    const c = ref.current;
    if (!c) return;
    const r = c.getBoundingClientRect();
    const dpr = window.devicePixelRatio || 1;
    c.width = Math.round(r.width * dpr);
    c.height = Math.round(r.height * dpr);
    const ctx = c.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, r.width, r.height);
    ctx.lineWidth = 2.4; ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.strokeStyle = '#111111';
  };
  useEffect(() => { setup(); }, []);
  const pos = (e) => { const r = ref.current.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; };
  const down = (e) => {
    if (disabled) return;
    e.preventDefault();
    ref.current.setPointerCapture && ref.current.setPointerCapture(e.pointerId);
    drawing.current = true; last.current = pos(e); setEmpty(false);
    const ctx = ref.current.getContext('2d');
    ctx.beginPath(); ctx.arc(last.current.x, last.current.y, 1.1, 0, Math.PI * 2); ctx.fillStyle = '#111111'; ctx.fill();
  };
  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const p = pos(e); const ctx = ref.current.getContext('2d');
    ctx.beginPath(); ctx.moveTo(last.current.x, last.current.y); ctx.lineTo(p.x, p.y); ctx.stroke();
    last.current = p;
  };
  const up = () => {
    if (!drawing.current) return;
    drawing.current = false;
    onChange(ref.current.toDataURL('image/png'));
  };
  const clear = () => { setup(); setEmpty(true); onChange(''); };
  return (
    <div>
      <div style={{ position: 'relative', border: '2px solid #111', background: '#fff' }}>
        <canvas ref={ref} onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerLeave={up} onPointerCancel={up}
          style={{ display: 'block', width: '100%', height: 190, touchAction: 'none', cursor: disabled ? 'not-allowed' : 'crosshair' }} data-testid="sig-pad" />
        {empty && <div style={{ position: 'absolute', inset: 0, display: 'grid', placeItems: 'center', pointerEvents: 'none', color: '#999', fontSize: 14 }}>Tanda tangan di sini (pakai jari / mouse)</div>}
        <div style={{ position: 'absolute', left: 16, right: 16, bottom: 38, borderBottom: '1.5px dashed #bbb', pointerEvents: 'none' }} />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 6, fontSize: 12, color: '#555' }}>
        <span>{empty ? 'Belum ada tanda tangan.' : 'Tanda tangan siap dikirim.'}</span>
        <button type="button" className="tvp-btn ghost" onClick={clear} disabled={disabled} data-testid="sig-clear">Hapus & ulangi</button>
      </div>
    </div>
  );
}

function Qty({ value, max, onChange, disabled }) {
  return (
    <span className="tvp-qty">
      <button type="button" disabled={disabled || value <= 0} onClick={() => onChange(Math.max(0, value - 1))}>-</button>
      <span>{value}</span>
      <button type="button" disabled={disabled || (max > 0 && value >= max)} onClick={() => onChange(value + 1)}>+</button>
    </span>
  );
}

export default function PortalPage() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState('');
  const [step, setStep] = useState(0);
  const [a1, setA1] = useState({});
  const [addons, setAddons] = useState({});
  const [pks, setPks] = useState({ agree: false, by: '', title: '', signature: '' });
  const [resign, setResign] = useState(false);
  const [busy, setBusy] = useState('');
  const [msg, setMsg] = useState(null);
  const [amount, setAmount] = useState('');
  const [booth, setBooth] = useState(null);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    document.title = 'Portal Tenant | Talesverse Memories Market';
    if (!document.getElementById('tvp-dmsans')) {
      const l = document.createElement('link');
      l.id = 'tvp-dmsans'; l.rel = 'stylesheet';
      l.href = 'https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&display=swap';
      document.head.appendChild(l);
    }
  }, []);

  const apply = (d, first) => {
    setData(d);
    const it = d.item;
    if (first) {
      const a = it.a1 || {};
      setA1({
        fascia_name: a.fascia_name || it.name || '', company_legal: a.company_legal || '', pic_name: a.pic_name || it.pic || '', pic_phone: a.pic_phone || it.phone || '',
        pic_email: a.pic_email || it.email || '', instagram: a.instagram || '', address: a.address || '', description: a.description || '',
        power_items: a.power_items || '', special_notes: a.special_notes || '', categories: a.categories || (it.category ? [it.category] : []),
      });
      setAddons(it.addons || {});
      if (it.pks && it.pks.signed && it.pks.via === 'portal') setPks({ agree: true, by: it.pks.by || '', title: it.pks.title || '', signature: '' });
      setStep(!it.a1_submitted_at ? 0 : (it.status === 'paid' ? 2 : 1));
    }
  };
  useEffect(() => {
    api.get(`/portal/${token}`).then(({ data: d }) => apply(d, true)).catch((e) => setErr(errOf(e, 'Link portal tidak valid.')));
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    let alive = true;
    const load = () => api.get(`/passport/booth/${token}`).then(({ data: d }) => { if (alive) { setBooth(d); setTick(d.expires_in || 0); } }).catch(() => {});
    load();
    const iv = setInterval(load, step === 3 ? 6000 : 60000);
    return () => { alive = false; clearInterval(iv); };
  }, [token, step]);
  useEffect(() => {
    if (step !== 3) return undefined;
    const iv = setInterval(() => setTick((t) => Math.max(0, t - 1)), 1000);
    return () => clearInterval(iv);
  }, [step]);

  const it = data ? data.item : null;
  const cfg = data ? data.config : {};
  const payments = (it && it.payments) || [];
  const busyPay = payments.some((p) => p.status === 'review' || p.status === 'confirmed');
  const locked = it && (it.status === 'paid' || busyPay) && it.a1_locked !== false;
  const expired = !!(it && it.a1_expired && !it.a1_submitted_at);
  const preview = useMemo(() => {
    if (!it) return { items: [], total: 0 };
    const items = [{ key: 'booth', label: `Booth ${it.booth_label || ''}`.trim(), qty: 1, unit: '', total: Number(it.booth_price) || 0 }];
    (cfg.addons || []).forEach((a) => { const q = Number(addons[a.key]) || 0; if (q > 0) items.push({ key: a.key, label: a.label, qty: q, unit: a.unit, price: a.price, total: q * (Number(a.price) || 0) }); });
    return { items, total: items.reduce((n, i) => n + i.total, 0) };
  }, [it, cfg, addons]);
  const inv = (it && it.invoice) || { items: [], total: 0, paid: 0, due: 0 };

  const set = (k) => (e) => setA1((o) => ({ ...o, [k]: e.target.value }));
  const toggle = (k, v) => setA1((o) => ({ ...o, [k]: (o[k] || []).includes(v) ? o[k].filter((x) => x !== v) : [...(o[k] || []), v] }));

  const submitA1 = async () => {
    const hasSig = !!pks.signature || !!(it && it.pks && it.pks.signature_url && !resign);
    if (!hasSig) { setMsg({ ok: false, t: 'Bubuhkan tanda tangan digital di kotak tanda tangan PKS.' }); return; }
    setBusy('a1'); setMsg(null);
    try {
      const { data: d } = await api.put(`/portal/${token}/a1`, { a1, addons, pks, origin: window.location.origin });
      setData((o) => ({ ...o, item: d.item }));
      setResign(false); setPks((o) => ({ ...o, signature: '' }));
      setMsg({ ok: true, t: 'Form A1 & PKS terkirim! Invoice sudah dikirim ke email kamu.' });
      setStep(1); window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (e) { setMsg({ ok: false, t: errOf(e) }); }
    finally { setBusy(''); }
  };
  const upload = async (kind, file, extra) => {
    if (!file) return;
    if (ASSET_SPEC[kind]) {
      const bad = await checkAsset(kind, file);
      if (bad) { setMsg({ ok: false, t: `${file.name}: ${bad}` }); return; }
    }
    setBusy(kind); setMsg(null);
    const fd = new FormData();
    fd.append('kind', kind); fd.append('file', file);
    if (extra) Object.entries(extra).forEach(([k, v]) => fd.append(k, v));
    try {
      const { data: d } = await api.post(`/portal/${token}/upload`, fd);
      setData((o) => ({ ...o, item: d.item }));
      setMsg({ ok: true, t: kind === 'payment' ? 'Bukti pembayaran terkirim. Panitia akan memverifikasi, konfirmasi dikirim via email/WhatsApp.' : kind === 'logo' ? 'Logo tersimpan.' : kind === 'cover' ? 'Ilustrasi cover tersimpan.' : 'Foto produk tersimpan.' });
      if (kind === 'payment') setAmount('');
    } catch (e) { setMsg({ ok: false, t: errOf(e) }); }
    finally { setBusy(''); }
  };
  const removeProduct = async (url) => {
    try { const { data: d } = await api.post(`/portal/${token}/product-remove`, { url }); setData((o) => ({ ...o, item: d.item })); } catch (e) { setMsg({ ok: false, t: errOf(e) }); }
  };

  if (err) {
    return (
      <div className="tvp"><style>{CSS}</style>
        <div className="tvp-wrap"><div className="tvp-card"><h1 className="tvp-h" style={{ fontSize: 22 }}>Portal tidak ditemukan</h1><p style={{ marginTop: 10 }}>{err}</p><p style={{ marginTop: 10, fontSize: 14 }}>Hubungi panitia di WhatsApp <b>+62 851-1056-6773</b>.</p></div></div>
      </div>
    );
  }
  if (!it) return <div className="tvp"><style>{CSS}</style><div className="tvp-wrap" style={{ textAlign: 'center', paddingTop: 120 }}>Memuat portal...</div></div>;

  const assets = it.assets || {};
  const prods = assets.products || [];
  const assetsDone = !!assets.logo_url && !!assets.cover_url && prods.length >= MIN_PRODUCTS;
  const steps = [['Form A1 & PKS', !!it.a1_submitted_at], ['Pembayaran', it.status === 'paid'], ['Aset Brand', assetsDone]];
  const showStamp = !!(booth && booth.enabled && booth.eligible);
  if (showStamp) steps.push(['QR Stamp', null]);
  const stampUrl = booth && booth.code ? `${window.location.origin}/passport?c=${encodeURIComponent(booth.code)}` : '';
  const statusText = { invited: 'Menunggu Form A1', awaiting_payment: 'Menunggu pembayaran', payment_review: 'Bukti bayar sedang diverifikasi', dp: 'DP diterima', paid: 'Lunas', draft: 'Menunggu Form A1' }[it.status] || it.status;
  const statusShown = expired ? 'Link expired' : statusText;

  return (
    <div className="tvp" data-testid="portal-page">
      <style>{CSS}</style>
      <div className="tvp-wrap">
        <div style={{ fontFamily: "'Akira Expanded', sans-serif", fontWeight: 800, fontSize: 12, letterSpacing: '.08em' }}>TALESVERSE MEMORIES MARKET | 12-13 DES 2026 | BRICKHALL FATMAWATI</div>
        <h1 className="tvp-h" style={{ fontSize: 'clamp(24px, 5vw, 38px)', margin: '10px 0 4px' }}>Portal Tenant</h1>
        <div style={{ fontSize: 18, fontWeight: 700 }}>{it.name}</div>

        <div className="tvp-card" style={{ marginTop: 18, display: 'flex', flexWrap: 'wrap', gap: 18, alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <span className="tvp-lbl">Booth kamu</span>
            <div style={{ fontWeight: 800, fontSize: 18 }}>{it.booth_label || 'Akan diinformasikan panitia'}</div>
          </div>
          <div>
            <span className="tvp-lbl">Status</span>
            <div style={{ fontWeight: 800, fontSize: 16 }} data-testid="portal-status">{statusShown}</div>
          </div>
          <div>
            <span className="tvp-lbl">Total tagihan</span>
            <div style={{ fontWeight: 800, fontSize: 18 }}>{it.a1_submitted_at ? rp(inv.total) : rp(preview.total)}</div>
          </div>
        </div>

        <div style={{ display: 'flex', gap: 8, marginTop: 18 }}>
          {steps.map(([l, done], i) => (
            <button key={l} type="button" onClick={() => setStep(i)} className={`tvp-step ${step === i ? 'on' : done ? 'done' : ''}`} data-testid={`portal-step-${i}`}>
              <div style={{ fontFamily: "'Akira Expanded', sans-serif", fontSize: 11, fontWeight: 800 }}>{i + 1}. {l}</div>
              <div style={{ fontSize: 11, marginTop: 2 }}>{done === null ? 'Saat event' : done ? 'Selesai' : 'Belum'}</div>
            </button>
          ))}
        </div>

        {msg && <div className={msg.ok ? 'tvp-ok' : 'tvp-bad'} style={{ marginTop: 16 }} data-testid="portal-msg">{msg.t}</div>}

        {step === 0 && (
          <div className="tvp-card" style={{ marginTop: 18 }}>
            <h2 className="tvp-h" style={{ fontSize: 20 }}>Form A1</h2>
            {!it.a1_submitted_at && it.a1_deadline && (expired ? (
              <div className="tvp-bad" style={{ marginTop: 12 }} data-testid="portal-expired"><b>Batas pengisian Form A1 & PKS sudah lewat</b> ({fmtDl(it.a1_deadline)}). Form tidak bisa dikirim lagi. Hubungi panitia di WhatsApp <b>+62 851-1056-6773</b> untuk perpanjangan.</div>
            ) : (
              <div className="tvp-note" style={{ marginTop: 12 }} data-testid="portal-deadline">Isi & kirim Form A1 + PKS sebelum <b>{fmtDl(it.a1_deadline)}</b> (sisa {Math.max(0, dLeft(it.a1_deadline) || 0)} hari). Lewat dari batas ini link otomatis expired.</div>
            ))}
            {locked && <div className="tvp-note" style={{ marginTop: 12 }}>Form A1 sudah terkunci karena pembayaran sedang/sudah diproses. Hubungi panitia kalau ada perubahan data.</div>}
            <fieldset disabled={locked || expired} style={{ border: 0, padding: 0, margin: 0, display: 'grid', gap: 16, marginTop: 16 }}>
              <div style={{ display: 'grid', gap: 16, gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))' }}>
                <Field label="Nama brand *" hint="Dipakai di papan booth & materi publikasi."><input className="tvp-in" value={a1.fascia_name || ''} onChange={set('fascia_name')} data-testid="a1-fascia" /></Field>
                <Field label="Nama badan usaha / pemilik"><input className="tvp-in" value={a1.company_legal || ''} onChange={set('company_legal')} /></Field>
                <Field label="Nama PIC *"><input className="tvp-in" value={a1.pic_name || ''} onChange={set('pic_name')} data-testid="a1-pic" /></Field>
                <Field label="No. WhatsApp PIC *"><input className="tvp-in" value={a1.pic_phone || ''} onChange={set('pic_phone')} inputMode="tel" data-testid="a1-phone" /></Field>
                <Field label="Email PIC *"><input className="tvp-in" type="email" value={a1.pic_email || ''} onChange={set('pic_email')} data-testid="a1-email" /></Field>
                <Field label="Instagram brand"><input className="tvp-in" value={a1.instagram || ''} onChange={set('instagram')} placeholder="@brand" /></Field>
              </div>
              <Field label="Alamat (untuk administrasi)"><input className="tvp-in" value={a1.address || ''} onChange={set('address')} /></Field>
              <div>
                <span className="tvp-lbl">Kategori produk</span>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>{CATS.map((c) => <span key={c} className={`tvp-chip ${(a1.categories || []).includes(c) ? 'on' : ''}`} onClick={() => !locked && toggle('categories', c)}>{c}</span>)}</div>
              </div>
              <Field label="Deskripsi produk yang dijual *"><textarea className="tvp-in" rows={3} value={a1.description || ''} onChange={set('description')} data-testid="a1-desc" /></Field>
              <Field label="Peralatan listrik yang dibawa"><input className="tvp-in" value={a1.power_items || ''} onChange={set('power_items')} placeholder="Lampu LED, kipas kecil" /></Field>
              <div className="tvp-note" data-testid="a1-crew-note"><b>ID card crew: 2 pcs</b> sudah termasuk paket booth, tanpa nama & no. HP. Butuh lebih dari 2? Tambah lewat Add-on di bawah.</div>
              <Field label="Catatan khusus untuk panitia"><textarea className="tvp-in" rows={2} value={a1.special_notes || ''} onChange={set('special_notes')} /></Field>

              <div style={{ borderTop: '2px solid #111', paddingTop: 16 }}>
                <h3 className="tvp-h" style={{ fontSize: 16 }}>Add-on</h3>
                {cfg.included_text && <p style={{ fontSize: 13, color: '#444', margin: '6px 0 10px' }}>{cfg.included_text}</p>}
                <table className="tvp-table">
                  <tbody>
                    {(cfg.addons || []).map((a) => (
                      <tr key={a.key} data-testid={`addon-${a.key}`}>
                        <td><b>{a.label}</b><div style={{ fontSize: 12, color: '#555' }}>{Number(a.price) > 0 ? `${rp(a.price)} / ${a.unit}` : 'Gratis'}{a.max ? ` | maks. ${a.max}` : ''}</div></td>
                        <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}><Qty value={Number(addons[a.key]) || 0} max={Number(a.max) || 0} disabled={locked} onChange={(v) => setAddons((o) => ({ ...o, [a.key]: v }))} /></td>
                        <td style={{ textAlign: 'right', whiteSpace: 'nowrap', width: 110, fontWeight: 700 }}>{rp((Number(addons[a.key]) || 0) * (Number(a.price) || 0))}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10, fontWeight: 800, fontSize: 16 }}><span>Estimasi total (booth + add-on)</span><span data-testid="portal-preview-total">{rp(preview.total)}</span></div>
              </div>

              <div style={{ borderTop: '2px solid #111', paddingTop: 16 }}>
                <h3 className="tvp-h" style={{ fontSize: 16, marginBottom: 10 }}>Perjanjian Kerja Sama (PKS)</h3>
                <div className="tvp-pks" data-testid="portal-pks">{cfg.pks_text}</div>
                <label style={{ display: 'flex', gap: 10, alignItems: 'flex-start', marginTop: 12, fontSize: 14, cursor: 'pointer' }}>
                  <input type="checkbox" checked={pks.agree} onChange={(e) => setPks((o) => ({ ...o, agree: e.target.checked }))} style={{ width: 20, height: 20, accentColor: '#111', marginTop: 1 }} data-testid="pks-agree" />
                  <span>Saya telah membaca dan menyetujui seluruh isi Perjanjian Kerja Sama di atas atas nama <b>{a1.fascia_name || it.name}</b>.</span>
                </label>
                <div style={{ display: 'grid', gap: 16, gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', marginTop: 12 }}>
                  <Field label="Nama penanda tangan *"><input className="tvp-in" value={pks.by} onChange={(e) => setPks((o) => ({ ...o, by: e.target.value }))} data-testid="pks-by" /></Field>
                  <Field label="Jabatan"><input className="tvp-in" value={pks.title} onChange={(e) => setPks((o) => ({ ...o, title: e.target.value }))} placeholder="Owner" /></Field>
                </div>
                <div style={{ marginTop: 14 }}>
                  <span className="tvp-lbl">Tanda tangan digital *</span>
                  {it.pks && it.pks.signature_url && !resign ? (
                    <div>
                      <div style={{ border: '2px solid #111', background: '#fff', padding: 8 }}><img src={resolveImageUrl(it.pks.signature_url)} alt="tanda tangan" style={{ display: 'block', maxHeight: 150, margin: '0 auto' }} data-testid="sig-saved" /></div>
                      {!locked && !expired && <button type="button" className="tvp-btn ghost" style={{ marginTop: 6 }} onClick={() => setResign(true)}>Tanda tangan ulang</button>}
                    </div>
                  ) : (
                    <SignaturePad disabled={locked || expired} onChange={(v) => setPks((o) => ({ ...o, signature: v }))} />
                  )}
                  <div style={{ fontSize: 12, color: '#555', marginTop: 6 }}>Dengan tanda tangan ini kamu menyetujui PKS secara elektronik atas nama <b>{pks.by || 'penanda tangan'}</b>{pks.title ? ` (${pks.title})` : ''}.</div>
                </div>
              </div>
            </fieldset>
            {!locked && (
              <div style={{ marginTop: 22 }}>
                <button type="button" className="tvp-btn" onClick={submitA1} disabled={busy === 'a1' || expired} data-testid="a1-submit">{busy === 'a1' ? 'Mengirim...' : it.a1_submitted_at ? 'Simpan perubahan' : 'Kirim Form A1 & setujui PKS'}</button>
              </div>
            )}
          </div>
        )}

        {step === 1 && (
          <div className="tvp-card" style={{ marginTop: 18 }}>
            <h2 className="tvp-h" style={{ fontSize: 20 }}>Pembayaran</h2>
            {!it.a1_submitted_at ? <div className="tvp-note" style={{ marginTop: 12 }}>Isi Form A1 & setujui PKS dulu, invoice akan muncul di sini.</div> : (
              <>
                <table className="tvp-table" style={{ marginTop: 12 }}>
                  <tbody>
                    {inv.items.map((i) => <tr key={i.key}><td>{i.label}{i.key !== 'booth' ? ` x${i.qty} ${i.unit}` : ''}</td><td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>{rp(i.total)}</td></tr>)}
                    {inv.pph > 0 && <tr><td>PPh 23 ({inv.pph_pct}%) di luar harga jual</td><td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>{rp(inv.pph)}</td></tr>}{inv.pph > 0 && <tr><td style={{ fontWeight: 700 }}>Total tagihan (DPP)</td><td style={{ textAlign: 'right', fontWeight: 700, whiteSpace: 'nowrap' }}>{rp(inv.gross)}</td></tr>}{inv.pph > 0 && <tr><td>PPh 23 dipotong &amp; disetor oleh kamu (kirim bukti potong ke panitia)</td><td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>({rp(inv.pph)})</td></tr>}<tr><td style={{ fontWeight: 800 }}>{inv.pph > 0 ? 'Total ditransfer' : 'Total'}</td><td style={{ textAlign: 'right', fontWeight: 800 }} data-testid="portal-total">{rp(inv.total)}</td></tr>
                    {inv.paid > 0 && <tr><td>Sudah dibayar</td><td style={{ textAlign: 'right', fontWeight: 700 }}>{rp(inv.paid)}</td></tr>}
                    {inv.paid > 0 && <tr><td>Sisa</td><td style={{ textAlign: 'right', fontWeight: 800 }}>{rp(inv.due)}</td></tr>}
                  </tbody>
                </table>
                {it.status === 'paid' ? (
                  <div className="tvp-ok" style={{ marginTop: 16 }} data-testid="portal-paid">
                    <b>Pembayaran terkonfirmasi. Terima kasih!</b> Lanjut upload aset brand (logo, ilustrasi cover & foto produk) di langkah 3.
                    {it.receipt_url && (
                      <div style={{ marginTop: 12 }}>
                        <a href={resolveImageUrl(it.receipt_url)} target="_blank" rel="noreferrer" className="tvp-btn ghost" style={{ textDecoration: 'none' }} data-testid="portal-receipt">Download invoice lunas (PDF)</a>
                        {it.receipt_no ? <span style={{ fontSize: 12, color: '#444', marginLeft: 10 }}>No. {it.receipt_no}</span> : null}
                      </div>
                    )}
                  </div>
                ) : (
                  <>
                    <div className="tvp-note" style={{ marginTop: 16 }}>
                      {cfg.bank_account ? <>Transfer ke:<br />{cfg.bank_name ? <>Bank: <b>{cfg.bank_name}</b><br /></> : null}No. Rekening: <b data-testid="pay-account">{cfg.bank_account}</b><br />Atas Nama: <b>{cfg.bank_holder}</b></> : 'Info rekening akan dikirim panitia via WhatsApp.'}
                      {cfg.payment_days ? <><br />Batas pembayaran: <b>{cfg.payment_days} hari</b> setelah Form A1 dikirim.</> : null}
                      {it.status === 'payment_review' && <><br /><b>Bukti bayar kamu sedang diverifikasi panitia.</b></>}
                    </div>
                    {it.status === 'dp' && it.receipt_url && (
                      <div className="tvp-note" style={{ marginTop: 12, display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }} data-testid="portal-receipt-dp">
                        <span>DP sudah diterima. Sisa tagihan <b>{rp(inv.due)}</b>.</span>
                        <a href={resolveImageUrl(it.receipt_url)} target="_blank" rel="noreferrer" className="tvp-btn ghost" style={{ textDecoration: 'none' }}>Download invoice DP (PDF)</a>
                      </div>
                    )}
                    <div style={{ display: 'grid', gap: 12, marginTop: 16 }}>
                      <Field label="Nominal yang ditransfer"><input className="tvp-in" value={amount} onChange={(e) => setAmount(e.target.value)} inputMode="numeric" placeholder={String(inv.due || inv.total)} data-testid="pay-amount" /></Field>
                      <label className="tvp-drop" data-testid="pay-drop">
                        <input type="file" accept="image/*,.pdf" style={{ display: 'none' }} onChange={(e) => { const f = e.target.files && e.target.files[0]; e.target.value = ''; upload('payment', f, { amount: amount || String(inv.due || inv.total) }); }} data-testid="pay-file" />
                        <span><b>{busy === 'payment' ? 'Mengunggah...' : 'Klik untuk upload bukti transfer'}</b><br />jpg / png / pdf, maks. 10MB</span>
                      </label>
                    </div>
                  </>
                )}
                {payments.length > 0 && (
                  <div style={{ marginTop: 18 }}>
                    <span className="tvp-lbl">Riwayat bukti pembayaran</span>
                    <table className="tvp-table"><tbody>
                      {[...payments].reverse().map((p) => (
                        <tr key={p.id}><td>{when(p.uploaded_at)}<div style={{ fontSize: 12, color: '#555' }}>{p.note}</div></td><td style={{ whiteSpace: 'nowrap' }}>{rp(p.amount)}</td>
                          <td style={{ textAlign: 'right', fontWeight: 800, whiteSpace: 'nowrap' }}>{p.status === 'review' ? 'Diverifikasi' : p.status === 'confirmed' ? `Diterima${p.kind === 'dp' ? ' (DP)' : ''}` : 'Ditolak'}</td></tr>
                      ))}
                    </tbody></table>
                  </div>
                )}
              </>
            )}
          </div>
        )}

        {step === 3 && showStamp && (
          <div className="tvp-card" style={{ marginTop: 18 }} data-testid="portal-stamp">
            <h2 className="tvp-h" style={{ fontSize: 20, margin: 0 }}>QR Stamp Memories Passport</h2>
            <p style={{ fontSize: 14, lineHeight: 1.55, margin: '8px 0 16px' }}>Pengunjung mengumpulkan stamp dari booth kamu. Cek dulu IG Story mereka (tag <b>@talesverse</b> + akun kamu), lalu tunjukkan QR ini untuk discan pakai kamera HP mereka.</p>
            {booth.open && booth.code ? (
              <div style={{ display: 'grid', justifyItems: 'center', gap: 10, border: '2px solid #111', padding: 16, background: '#fff' }}>
                <QrImg text={stampUrl} size={280} testid="portal-stamp-qr" />
                <div style={{ fontFamily: "'Akira Expanded', sans-serif", fontWeight: 800, fontSize: 18 }}>{it.name}</div>
                <div style={{ fontSize: 12 }}>QR berganti otomatis dalam <b>{tick} detik</b>. Jangan difoto/dibagikan, QR lama tidak berlaku.</div>
              </div>
            ) : (
              <div className="tvp-note">{booth.closed_reason || 'QR stamp aktif saat hari event.'}</div>
            )}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8, marginTop: 16, textAlign: 'center' }}>
              {[['Jam ini', booth.this_hour], ['Hari ini', booth.today], ['Total', booth.total]].map(([l, n]) => (
                <div key={l} style={{ border: '2px solid #111', padding: '10px 4px', background: '#FAFAF7' }}>
                  <div style={{ fontFamily: "'Akira Expanded', sans-serif", fontWeight: 800, fontSize: 22 }}>{n || 0}</div>
                  <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.06em' }}>{l}</div>
                </div>
              ))}
            </div>
            <p style={{ fontSize: 12, color: '#555', margin: '12px 0 0' }}>Tips: buka halaman ini di HP/tablet khusus untuk booth, naikkan kecerahan layar. Kalau HP mati, pakai QR cetak dari panitia.</p>
          </div>
        )}

        {step === 2 && (
          <div className="tvp-card" style={{ marginTop: 18 }}>
            <h2 className="tvp-h" style={{ fontSize: 20 }}>Aset brand</h2>
            <p style={{ fontSize: 14, color: '#444', marginTop: 8 }}>
              Semua aset di bawah akan <b>diposting di Instagram Talesverse</b> (lihat guide di bawah).{cfg.auto_logo ? ' Logo juga tampil otomatis di line up website setelah pembayaran terkonfirmasi.' : ''}
            </p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 12 }} data-testid="asset-checklist">
              <span className={`tvp-tag ${assets.logo_url ? 'ok' : ''}`}>{assets.logo_url ? 'OK' : 'Belum'} | Logo brand (1)</span>
              <span className={`tvp-tag ${assets.cover_url ? 'ok' : ''}`}>{assets.cover_url ? 'OK' : 'Belum'} | Ilustrasi cover (1)</span>
              <span className={`tvp-tag ${prods.length >= MIN_PRODUCTS ? 'ok' : ''}`}>{prods.length >= MIN_PRODUCTS ? 'OK' : 'Belum'} | Foto produk ({prods.length}/{MIN_PRODUCTS} minimal)</span>
            </div>
            {it.status === 'paid' && it.receipt_url && (
              <div className="tvp-note" style={{ marginTop: 12, display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }} data-testid="assets-receipt">
                <span>Pembayaran <b>LUNAS</b>. Simpan invoice pelunasan kamu:</span>
                <a href={resolveImageUrl(it.receipt_url)} target="_blank" rel="noreferrer" className="tvp-btn ghost" style={{ textDecoration: 'none' }}>Download invoice (PDF)</a>
              </div>
            )}
            <div style={{ border: '2px solid #111', marginTop: 14, overflowX: 'auto' }} data-testid="asset-spec">
              <table className="tvp-table tvp-spec" style={{ margin: 0 }}>
                <thead><tr><th>Spesifikasi file</th><th>Rasio</th><th>Minimal</th><th>Disarankan (HD)</th></tr></thead>
                <tbody>
                  <tr><td><b>Logo brand</b></td><td>1:1 persegi</td><td>600 x 600 px</td><td>1000 x 1000 px, PNG transparan</td></tr>
                  <tr><td><b>Ilustrasi cover</b></td><td>3:4 portrait</td><td>1080 x 1440 px</td><td>2160 x 2880 px</td></tr>
                  <tr><td><b>Foto produk</b> (min. 3)</td><td>3:4 portrait</td><td>1080 x 1440 px</td><td>2160 x 2880 px</td></tr>
                </tbody>
              </table>
              <div style={{ fontSize: 12, color: '#555', padding: '8px 10px', borderTop: '1px solid #ddd' }}>Format JPG / PNG / WEBP, maks. 25MB per file. File di luar spesifikasi otomatis ditolak supaya hasil posting Instagram tetap tajam.</div>
            </div>
            <CaptionBox token={token} value={assets.caption || ''} onSaved={(item) => setData((o) => ({ ...o, item }))} />
{assetsDone && <div className="tvp-ok" style={{ marginTop: 12 }} data-testid="assets-done"><b>Aset lengkap. Terima kasih!</b> Tim kami akan menyiapkan posting Instagram brand kamu.</div>}

            <div style={{ display: 'grid', gap: 18, gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', marginTop: 16 }}>
              <div>
                <span className="tvp-lbl">Logo brand *</span>
                <label className="tvp-drop" style={{ aspectRatio: '1 / 1', padding: 10 }} data-testid="logo-drop">
                  <input type="file" accept={ASSET_ACCEPT} style={{ display: 'none' }} onChange={(e) => { const f = e.target.files && e.target.files[0]; e.target.value = ''; upload('logo', f); }} data-testid="logo-file" />
                  {assets.logo_url ? <img src={resolveImageUrl(assets.logo_url)} alt="logo" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} /> : <span><b>{busy === 'logo' ? 'Mengunggah...' : 'Klik untuk upload logo'}</b><br />1:1, min. 600 x 600 px</span>}
                </label>
                <div style={{ fontSize: 12, marginTop: 6 }}>{busy === 'logo' ? 'Mengunggah...' : assets.logo_url ? 'Klik gambar untuk mengganti.' : 'Rasio 1:1, min. 600 x 600 px (disarankan 1000 x 1000 px, PNG transparan).'}</div>
              </div>
              <div>
                <span className="tvp-lbl">Ilustrasi cover *</span>
                <label className="tvp-drop" style={{ aspectRatio: '3 / 4', padding: assets.cover_url ? 0 : 10, overflow: 'hidden' }} data-testid="cover-drop">
                  <input type="file" accept={ASSET_ACCEPT} style={{ display: 'none' }} onChange={(e) => { const f = e.target.files && e.target.files[0]; e.target.value = ''; upload('cover', f); }} data-testid="cover-file" />
                  {assets.cover_url ? <img src={`${resolveImageUrl(assets.cover_url)}?w=640`} alt="cover" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <span><b>{busy === 'cover' ? 'Mengunggah...' : 'Klik untuk upload ilustrasi'}</b><br />portrait 3:4, min. 1080 x 1440 px</span>}
                </label>
                <div style={{ fontSize: 12, marginTop: 6 }}>{busy === 'cover' ? 'Mengunggah...' : assets.cover_url ? 'Klik gambar untuk mengganti.' : 'Portrait 3:4, min. 1080 x 1440 px. HD disarankan 2160 x 2880 px.'}</div>
              </div>
            </div>

            <div style={{ marginTop: 18 }}>
              <span className="tvp-lbl">Foto produk * ({prods.length}/{MAX_PRODUCTS}, minimal {MIN_PRODUCTS}) | 3:4, min. 1080 x 1440 px</span>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))', gap: 8 }}>
                {prods.map((u) => (
                  <div key={u} style={{ position: 'relative', border: '1.5px solid #111', aspectRatio: '3 / 4', background: '#fff' }}>
                    <img src={`${resolveImageUrl(u)}?w=320`} alt="produk" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    <button type="button" onClick={() => removeProduct(u)} style={{ position: 'absolute', top: 4, right: 4, background: '#111', color: '#fff', border: 0, width: 22, height: 22, cursor: 'pointer' }}>x</button>
                  </div>
                ))}
                {prods.length < MAX_PRODUCTS && (
                  <label className="tvp-drop" style={{ aspectRatio: '3 / 4', padding: 6 }} data-testid="product-drop">
                    <input type="file" accept={ASSET_ACCEPT} multiple style={{ display: 'none' }} onChange={async (e) => { const files = Array.from(e.target.files || []); e.target.value = ''; for (const f of files) { await upload('product', f); } }} data-testid="product-file" />
                    <span style={{ fontSize: 12 }}><b>{busy === 'product' ? '...' : '+ Foto'}</b></span>
                  </label>
                )}
              </div>
            </div>

            <div style={{ borderTop: '2px solid #111', paddingTop: 16, marginTop: 22 }}>
              <h3 className="tvp-h" style={{ fontSize: 16 }}>Guide posting Instagram</h3>
              <p style={{ fontSize: 13, color: '#444', margin: '6px 0 12px' }}>Begini aset kamu akan ditampilkan di Instagram Talesverse. Siapkan file sesuai panduan supaya hasilnya maksimal.</p>
              <div style={{ display: 'grid', gap: 14, gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))' }} data-testid="ig-guide">
                <div className="tvp-guide">
                  <span className="tvp-lbl" style={{ margin: 0 }}>Post 1 | Logo + ilustrasi cover</span>
                  <img src="/guide/ig-cover.webp" alt="Contoh posting logo dan ilustrasi cover" loading="lazy" />
                  <ul>
                    <li>Ilustrasi cover dipakai <b>full sebagai background</b>.</li>
                    <li>Logo Talesverse & tanggal di atas, <b>nama brand</b> di band biru bawah, <b>logo kamu</b> di pojok kanan bawah.</li>
                    <li>Hindari detail penting di area atas dan bawah gambar.</li>
                    <li>Format portrait 3:4, minimal 1080 x 1440 px (HD: 2160 x 2880 px).</li>
                  </ul>
                </div>
                <div className="tvp-guide">
                  <span className="tvp-lbl" style={{ margin: 0 }}>Post 2 | Foto produk (carousel)</span>
                  <img src="/guide/ig-product.webp" alt="Contoh posting foto produk" loading="lazy" />
                  <ul>
                    <li>Setiap foto produk jadi <b>1 slide</b> carousel.</li>
                    <li>Logo Talesverse & tanggal di atas, website di bawah, beri sedikit ruang kosong.</li>
                    <li>Foto terang, tajam, produk terlihat jelas (bukan kolase).</li>
                    <li>Format portrait 3:4, minimal 1080 x 1440 px (HD: 2160 x 2880 px).</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}

        <p style={{ fontSize: 13, color: '#444', marginTop: 26, textAlign: 'center' }}>Ada pertanyaan? WhatsApp panitia <b>+62 851-1056-6773</b> | partnership@luckytalesgroup.com</p>
      </div>
    </div>
  );
}

function CaptionBox({ token, value, onSaved }) {
  const [v, setV] = useState(value || '');
  const [st, setSt] = useState('');
  useEffect(() => { setV(value || ''); }, [value]);
  const dirty = (v || '') !== (value || '');
  const save = async () => {
    setSt('saving');
    try {
      const { data: d } = await api.put(`/portal/${token}/caption`, { caption: v });
      onSaved(d.item);
      setSt('ok');
    } catch (e) {
      setSt('err:' + ((e && e.response && e.response.data && e.response.data.detail) || 'Gagal menyimpan caption.'));
    }
  };
  return (
    <div style={{ marginTop: 16 }} data-testid="caption-box">
      <span className="tvp-lbl">Caption Instagram</span>
      <div style={{ fontSize: 12, color: '#555', margin: '2px 0 6px' }}>Caption untuk posting brand kamu di Instagram Talesverse: cerita singkat brand, produk andalan, akun IG kamu, dan hashtag. Maks. 2.200 karakter.</div>
      <textarea className="tvp-in" rows={6} maxLength={2200} value={v} onChange={(e) => { setV(e.target.value); setSt(''); }} placeholder="Contoh: Halo Citizens! Kenalan dulu sama @brandkamu ..." style={{ width: '100%', resize: 'vertical', fontFamily: 'inherit' }} data-testid="caption-input" />
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 8, flexWrap: 'wrap' }}>
        <button type="button" className="tvp-btn" disabled={!dirty || st === 'saving'} onClick={save} data-testid="caption-save">{st === 'saving' ? 'Menyimpan...' : 'Simpan caption'}</button>
        <span style={{ fontSize: 12, color: '#555' }}>{(v || '').length}/2200</span>
        {st === 'ok' && <span style={{ fontSize: 12, fontWeight: 700, color: '#1a7f37' }}>Caption tersimpan.</span>}
        {st.startsWith('err:') && <span style={{ fontSize: 12, fontWeight: 700, color: '#c0392b' }}>{st.slice(4)}</span>}
      </div>
    </div>
  );
}
